import { useFormContext } from '@calendly/form'
import { I18n } from '@calendly/i18n'
import { BodyText } from '@calendly/ui/components/typography'
import { Fragment } from 'react'

import { useEventType } from 'features/event_type_provider'

import { determineTextNotifications, determineTextWorkflows, questionsToCards, showLocationQuestion } from './helpers'


export const LockedInviteeQuestionsSection = ({ workflows }) => {
  const eventType = useEventType()
  const { values: { inviteeQuestions, nameFormat } } = useFormContext()

  const staticQuestions = [
    {
      title: nameFormat === 'combined'
        ? I18n.t('publisher.event_types.invitee_questions.name_and_email')
        : I18n.t('publisher.event_type_editor.sections.booking_page_options.invitee_questions.first_name_last_name_email'),
    }
  ]

  if (!eventType.isGroup) {
    staticQuestions.push({
      title: I18n.t('publisher.event_type_editor.sections.booking_page_options.invitee_questions.allow_invitees_to_add_guests'),
    })
  }

  const hasLocationQuestion = showLocationQuestion(eventType)

  if (hasLocationQuestion) {
    staticQuestions.push({
      title: I18n.t('publisher.event_types.invitee_questions.location_options'),
    })
  }

  const hasTextNotifications = determineTextNotifications(eventType)
  const hasTextWorkflows = determineTextWorkflows(workflows)

  if (hasTextNotifications || hasTextWorkflows) {
    staticQuestions.push({
      title: I18n.t('publisher.event_type_editor.sections.booking_page_options.invitee_questions.text_number'),
    })
  }

  const undeletedQuestions = inviteeQuestions.filter(({ _destroy }) => !_destroy)
  const additionalQuestions = questionsToCards(undeletedQuestions)

  return (
    <>
      {staticQuestions.map(({ title }) => <BodyText key={title}>{title}</BodyText>)}
      {additionalQuestions.map(({ title, subtitle }) => (
        <Fragment key={title}>
          <BodyText>{title}</BodyText>
          <BodyText color="muted">{subtitle}</BodyText>
        </Fragment>
      ))}
    </>
  )
}
